const FeatureCodesMapping = {
  BUNDLE_JUS_AI: 'bundle_jus_ai',
  LEGAL_SEARCH_AI: 'legal_search_ai',
  DOCUMENT_DRAFTING_AI: 'document_drafting_ai',
  DOCUMENT_ANALYSIS_AI: 'document_analysis_ai',
}

export const AI_FEATURES = [
  FeatureCodesMapping.BUNDLE_JUS_AI,
  FeatureCodesMapping.DOCUMENT_ANALYSIS_AI,
  FeatureCodesMapping.DOCUMENT_DRAFTING_AI,
  FeatureCodesMapping.LEGAL_SEARCH_AI,
]
